<div class="row justify-content-center mt-3  d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <app-upload-and-preview [apiUrl]="baseUrl" [requestCode]="'5011'" [docType]="'identity proof'"
            [subDocType]="'pan'" (apiResponse)="ProceedToDocUpload($event)" [maxFileCount]="1">
            <h3 class="heading">Identity Proof</h3>
            <p class="heading1">Please provide your PAN Card as identity proof</p>
            <p class="uploaddocfooter text-success mb-0">Please upload the documents only in JPEG, PNG or PDF format</p>
        </app-upload-and-preview>
    </div>
    <div class="col-lg-5 col-11">
        <app-assist-left></app-assist-left>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>